<div class="pl-donut flex h-full flex-col items-center gap-4">
  <div
    class="h-full w-full"
    [ngClass]="{
      locked: isLocked
    }"
    #chartContainer
  ></div>
  <div class="flex items-center gap-4">
    <div>
      <p
        *ngIf="title"
        class="text-xs font-bold uppercase"
        [ngClass]="isLocked ? 'text-pl-gray-400' : 'text-pl-orange-800'"
      >
        {{ title }}
      </p>
      <p *ngIf="title" class="text-lg font-bold" [ngClass]="isLocked ? 'text-pl-gray-400' : 'text-pl-gray-700'">
        {{ subtitle }}
      </p>
    </div>
    <pl-icon *ngIf="isLocked" [name]="PlIcon.lock" class="h-6 w-6 text-pl-gray-400" />
  </div>
</div>
